import { render } from "./Container.vue?vue&type=template&id=0f30bb56"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
script.render = render

export default script